import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconColumnSort = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.4375 14.0625H6.5625C6.045 14.0625 5.625 13.6425 5.625 13.125C5.625 12.6075 6.045 12.1875 6.5625 12.1875H8.4375C8.955 12.1875 9.375 12.6075 9.375 13.125C9.375 13.6425 8.955 14.0625 8.4375 14.0625Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3125 10.3125H4.6875C4.17 10.3125 3.75 9.8925 3.75 9.375C3.75 8.8575 4.17 8.4375 4.6875 8.4375H10.3125C10.83 8.4375 11.25 8.8575 11.25 9.375C11.25 9.8925 10.83 10.3125 10.3125 10.3125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1875 6.5625H2.8125C2.295 6.5625 1.875 6.1425 1.875 5.625C1.875 5.1075 2.295 4.6875 2.8125 4.6875H12.1875C12.705 4.6875 13.125 5.1075 13.125 5.625C13.125 6.1425 12.705 6.5625 12.1875 6.5625Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0625 2.8125H0.9375C0.42 2.8125 0 2.3925 0 1.875C0 1.3575 0.42 0.9375 0.9375 0.9375H14.0625C14.58 0.9375 15 1.3575 15 1.875C15 2.3925 14.58 2.8125 14.0625 2.8125Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconColumnSort;
